import { Component } from "react";
import logo from "../../assets/01pos.webp";

// Keeps a render error in the cashier page from blanking the whole app.
class CashierErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Cashier page crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-customBlue flex flex-col justify-center items-center px-6 text-center gap-6">
        <img src={logo} alt="01POS" className="w-32" />
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-sm w-full flex flex-col items-center gap-4">
          <p className="text-gray-600 text-sm leading-relaxed">
            Something went wrong loading the cashier page. Please reload. If it
            keeps happening, contact support.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-2 rounded-lg bg-black text-white font-medium hover:bg-gray-800"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default CashierErrorBoundary;
